module.exports = __webpack_public_path__ + "img/XAI6.e90455dc.jpg";